
<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="here px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">お届け先、お届け日、お支払方法</h3>
    <p class="exp">
      以下の必要な項目をご入力のうえ、確認画面へ進むを押してください。
    </p>

    <div class="form-member my-5">
      <div class="inner">
        <dl style="margin-bottom: 0; border-bottom: 0">
          <dt>お受取りについて<span class="rqr">必須</span></dt>
          <dd>
            初回のご注文はご本人受取りとなります。<br />
            同意いただける方は「本人が受取ることを同意する」にチェックをいれてください。<br />
            <input
              v-model="consent"
              ref="consent"
              id="chkBySelf"
              type="checkbox"
              class="check-01"
            />
            <label for="chkBySelf"
              ><strong>本人が受取ることを同意する</strong></label
            >
          </dd>
          <dt>お届け先<span class="rqr">必須</span></dt>
          <dd>
            <input
              v-model="isHome"
              id="rdoHomeY"
              name="home"
              type="radio"
              class="radio-01"
              value="true"
            />
            <label for="rdoHomeY">ご自宅</label>
            <input
              v-model="isHome"
              id="rdoHomeN"
              name="home"
              type="radio"
              class="radio-01 ml-2e"
              value="false"
            />
            <label for="rdoHomeN">ご自宅以外</label>
          </dd>
        </dl>

        <!-- ご自宅以外選択で追加 -->
        <dl
          v-show="isHome == 'false'"
          id="dlAddress"
          style="margin-bottom: 0; border-bottom: 0"
        >
          <dt style="width: 100%; float: none; background: #fff">
            ※ご自宅以外のお届け先をご記入ください。
          </dt>
          <dt>郵便番号<span class="rqr">必須</span></dt>
          <dd>
            〒
            <input
              v-model="zipCode2"
              ref="zipCode2"
              id="txtZipCode"
              type="text"
              class="input-name"
              placeholder="(例)2790032"
              style="ime-mode: disabled"
            />
            <button
              id="spnZipSearch"
              v-on:click="zipSearch"
              class="p-serch ml-3 mt-2"
            >
              住所検索</button
            ><br />
            <p class="fs-09">ハイフン(-)は除いてください。</p>
          </dd>
          <dt>住所<span class="rqr">必須</span></dt>
          <dd>
            <input
              v-model="part1OfAddress"
              ref="part1OfAddress"
              id="txtAddress1"
              maxlength="100"
              type="text"
              class="w-100"
              placeholder="(例)千葉県浦安市千鳥15-9"
              style="ime-mode: active"
            />
          </dd>
          <dt>
            住所<span class="fs-08">（フリガナ）</span
            ><span class="rqr">必須</span>
          </dt>
          <dd>
            <input
              v-model="addressKana"
              ref="addressKana"
              id="txtAddressKana"
              maxlength="300"
              type="text"
              class="w-100"
              placeholder="(例)チバケンウラヤスシチドリ15バンチ8"
              style="ime-mode: active"
            /><br />
            <p class="fs-09">カタカナで入力してください</p>
          </dd>
          <dt>住所<span class="fs-08">（建物名）</span></dt>
          <dd>
            <input
              v-model="part2OfAddress"
              ref="part2OfAddress"
              id="txtAddress2"
              maxlength="100"
              type="text"
              class="w-100"
              placeholder="(例)マナビスマンション101"
              style="ime-mode: active"
            />
          </dd>
          <dt>宛先</dt>
          <dd>
            <input
              v-model="part3OfAddress"
              ref="part3OfAddress"
              id="txtAddress3"
              maxlength="100"
              type="text"
              class="input-name"
              placeholder="(例)浦安 舞子"
              style="ime-mode: active"
            />
            <select
              v-model="part3Add"
              ref="part3Add"
              id="selAddress3Add"
              class="px-3"
            >
              <option value="">－</option>
              <option value="様方">様方</option>
              <option value="気付">気付</option>
            </select>
          </dd>
          <dt>電話番号<span class="rqr">必須</span></dt>
          <dd>
            <input
              v-model="telNo"
              ref="telNo"
              id="txtTel"
              maxlength="12"
              type="text"
              class="input-w30"
              placeholder="(例)9999999999"
              style="ime-mode: disabled"
            /><br />
            <p class="fs-09">ハイフン(-)は除いてください。</p>
          </dd>
        </dl>
        <!-- // ご自宅以外選択で追加 -->

        <dl>
          <dt>お届け指定日<span class="rqr">必須</span></dt>
          <dd>
            <select
              v-model="deliveryDate"
              ref="deliveryDate"
              id="cmbWantDay"
              class="px-3"
            >
              <option value="">－</option>
              <option v-for="date in deliveryDays" :key="date" :value="date">
                {{ date }}
              </option>
            </select>
          </dd>
          <dt>お届け時間帯<span class="rqr">必須</span></dt>
          <dd>
            <select
              v-model="deliveryTime"
              ref="deliveryTime"
              id="cmbWantTime"
              class="px-3"
            >
              <option value="">－</option>
              <option
                v-for="time in deliveryTimes"
                :key="time.Key"
                :value="time.Key"
              >
                {{ time.Value }}
              </option>
            </select>
          </dd>
          <dt>お支払方法<span class="rqr">必須</span></dt>
          <dd>
            <dl class="c-radio" data-v-19516808="">
              <dt data-v-19516808="">
                <input
                  id="daibiki"
                  type="radio"
                  v-model="paymentMethod"
                  ref="paymentMethod"
                  value="0"
                  name="PayMethod"
                  data-v-19516808=""
                /><label for="daibiki" data-v-19516808=""
                  ><strong data-v-19516808="">代金引換</strong></label
                >
              </dt>
              <dd data-v-19516808="">
                ※代金引換の場合には別途代金引換手数料として<span
                  data-v-19516808=""
                  >300</span
                >円が商品代金に加算されます
              </dd>
            </dl>
            <dl class="c-radio borders" data-v-19516808="">
              <dt id="dtCredit" data-v-19516808="">
                <input
                  id="credit"
                  type="radio"
                  v-model="paymentMethod"
                  ref="paymentMethod"
                  value="3"
                  name="PayMethod"
                  data-v-19516808=""
                /><label for="credit" data-v-19516808=""
                  ><strong data-v-19516808="">クレジットカード</strong></label
                >
              </dt>
              <dd id="ddCredit" data-v-19516808="">
                ※クレジットカード決済の場合は、カード会社サイトで決済のための入力が必要になります。<br
                  data-v-19516808=""
                /><img
                  id="Visa"
                  class="mr-2 mt-2"
                  src="data:image/gif;base64,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"
                  alt="visa"
                  data-v-19516808=""
                /><img
                  id="Master"
                  class="mr-2 mt-2"
                  src="data:image/png;base64,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"
                  alt="master"
                  data-v-19516808=""
                /><img
                  id="JCB"
                  class="mr-2 mt-2"
                  src="data:image/gif;base64,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"
                  alt="jcb"
                  data-v-19516808=""
                /><img
                  id="AE"
                  class="mr-2 mt-2"
                  src="data:image/gif;base64,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"
                  alt="ae"
                  data-v-19516808=""
                /><img
                  id="Diners"
                  class="mr-2 mt-2"
                  src="data:image/gif;base64,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"
                  alt="diners"
                  data-v-19516808=""
                />
              </dd>
            </dl>
          </dd>
          <!-- <dd>
            <input
              id="rdoPayCod"
              v-model="paymentMethod"
              ref="paymentMethod"
              value="0"
              name="PayMethod"
              type="radio"
              class="radio-01"
            />
            <label for="rdoPayCod">代金引換</label> -->
          <!-- <input
              id="rdoPayBank"
              v-model="paymentMethod"
              ref="paymentMethod"
              value="1"
              name="PayMethod"
              type="radio"
              class="radio-01 ml-2e"
            />
            <label for="rdoPayBank">銀行振込（前払い）</label> -->
          <!-- <input
              id="rdoPayCard"
              v-model="paymentMethod"
              ref="paymentMethod"
              value="3"
              name="PayMethod"
              type="radio"
              class="radio-01 ml-2e"
            />
            <label for="rdoPayCard">クレジットカード</label>
          </dd> -->
        </dl>
        <div
          class="d-flex justify-content-around text-center column_sp box-p-20"
        >
          <div>
            <router-link
              :to="{ path: '/shopping/order/confirm' }"
              class="btn d-inline-block mt-5"
            >
              カートへ戻る
            </router-link>
          </div>
          <div>
            <button
              v-on:click="putData"
              id="btnConfirm"
              type="button"
              class="confirm-01 clear mt-5"
            >
              確認画面へ進む
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
import Message from "@/modules/Message";
import Utl from "@/modules/Utl";
export default {
  data() {
    return {
      consent: "",
      isHome: "",
      zipCode2: "",
      deliveryDate: "",
      deliveryTime: "",
      paymentMethod: "",
      part1OfAddress: "",
      part2OfAddress: "",
      part3OfAddress: "",
      part3Add: "",
      addressKana: "",
      telNo: "",
      deliveryDays: [],
      deliveryTimes: [],
    };
  },
  mounted() {
    this.getData();
    window.scroll(0, 0);
  },
  watch: {
    deliveryDate: function () {
      this.getDeliveryTime();
    },
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getDelivery",
        [true],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.isHome = data.isHome.toString();
          this.zipCode2 = data.zipCode2;
          this.paymentMethod = data.paymentMethod;
          this.part1OfAddress = data.part1OfAddress;
          this.part2OfAddress = data.part2OfAddress;
          this.part3OfAddress = data.part3OfAddress;
          this.part3Add = data.part3Add;
          this.addressKana = data.addressKana;
          this.telNo = data.telNo;
          this.getDeliveryDays();
        });
    },
    getDeliveryDays() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getDeliveryDays",
        [this.isHome, this.zipCode2],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.deliveryDays = data.DeliveryDays;
          this.getDeliveryTime();
        });
    },
    getDeliveryTime() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getDeliveryTime",
        [this.deliveryDate],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.deliveryTimes = data.DeliveryTime;
        });
    },
    putData() {
      if (!this.chkConsent()) return;
      if (this.isHome == "false") {
        if (!this.chkZipCode()) return;
        if (!this.chkAddress()) return;
        if (!this.chkTelNo()) return;
      }
      if (!this.chkDeliveryDate()) return;
      if (!this.chkDeliveryTime()) return;
      if (!this.chkPaymentMethod()) return;
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putDelivery",
        [
          this.isHome,
          this.zipCode2,
          this.deliveryDate,
          this.deliveryTime,
          this.paymentMethod,
          this.part1OfAddress,
          this.addressKana,
          this.part2OfAddress,
          this.part3OfAddress,
          this.part3Add,
          this.telNo,
        ],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
              didClose: () => {
                switch (data.arg) {
                  case "ZipCode":
                    this.$refs.zipCode2.focus();
                    break;
                  case "Address1":
                    this.$refs.part1OfAddress.focus();
                    break;
                  case "TelNo":
                    this.$refs.telNo.focus();
                    break;
                }
              },
            });
            return;
          }
          this.$router.push("/shopping/delivery/confirm");
        });
    },
    zipSearch() {
      if (!this.chkZipCode()) return;
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getAddressFromZip",
        [this.zipCode2],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
              didClose: () => {
                this.$refs.zipCode2.focus();
                return;
              },
            });
          }
          this.part1OfAddress = data.address;
          this.addressKana = data.addressKana;
        });
    },
    chkConsent() {
      if (!this.consent) {
        Message.error().fire({
          title:
            "ご本人様が受け取る事に同意いただける方は「本人が受取ることを同意する」にチェックを入れてください。",
          didClose: () => {
            this.$refs.consent.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkZipCode() {
      let mes = Utl.chkMustInput("郵便番号", this.zipCode2);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.zipCode2.focus();
          },
        });
        return false;
      }
      mes = Utl.chkZipCode("郵便番号", this.zipCode2);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.zipCode2.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkAddress() {
      let mes = Utl.chkMustInput("住所", this.part1OfAddress);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.part1OfAddress.focus();
          },
        });
        return false;
      }
      mes = Utl.chkMustInput("住所(フリガナ)", this.addressKana);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.addressKana.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkTelNo() {
      if (this.telNo.length == 0) {
        Message.error().fire({
          title: "電話番号を入力してください。",
          didClose: () => {
            this.$refs.telNo.focus();
          },
        });
        return false;
      }
      let mes = Utl.chkNum("電話番号", this.telNo);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.telNo.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkDeliveryDate() {
      if (this.deliveryDate.length == 0) {
        Message.error().fire({
          title: "お届け指定日を選択してださい。",
          didClose: () => {
            this.$refs.deliveryDate.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkDeliveryTime() {
      if (this.deliveryTime.length == 0) {
        Message.error().fire({
          title: "お届け時間帯を選択してください。",
          didClose: () => {
            this.$refs.deliveryTime.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkPaymentMethod() {
      if (this.paymentMethod.length == 0) {
        Message.error().fire({
          title: "お支払い方法を選択してください。",
          didClose: () => {
            this.$refs.paymentMethod.focus();
          },
        });
        return false;
      }
      return true;
    },
  },
};
</script>